import moment from 'moment';
import 'moment-timezone';

/**
 * Pickup DATE display for the status card when WALHQ has confirmed the day but not yet a time
 * (Lucas, 2026-09-05: the date is nearly always confirmed, the times may come later; the card
 * falls back to the shipper's business-hours window first, and to the bare date when there is
 * no window either). Same day words as getDynamicPickupTimeDisplay, without the time.
 */
export const getDynamicPickupDateDisplay = (pickupDate: string | null | undefined, timezone: string | null | undefined): string => {
    if (!pickupDate || !timezone) return '';

    // Schedule dates arrive as YYYY-MM-DD; take the date part only so an ISO timestamp can never
    // shift the day through a timezone conversion (same rule as the scheduling section).
    const day = moment.tz(String(pickupDate).slice(0, 10), 'YYYY-MM-DD', true, timezone).startOf('day');
    if (!day.isValid()) return '';

    const today = moment.tz(timezone).startOf('day');
    const days = day.diff(today, 'days');
    const dateDisplay = day.format('MMM Do, YYYY');

    if (days === 0) return 'Today';
    if (days === 1) return 'Tomorrow';
    if (days === -1) return 'Yesterday';
    if (days < 0) return days > -7 ? day.format('dddd') : day.format('MMM Do');
    if (days < 3) return day.format('dddd');
    if (days < 5) return `in ${days} days (${dateDisplay})`;

    return `on ${dateDisplay}`;
};
